// noinspection JSDeprecatedSymbols

import _ from "lodash";

// export const isMobileServer = (userAgent: string): boolean => {
//   if (!userAgent) return false;
//
//   const mobileRegex =
//     /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|kindle|silk|playbook|bb10|meego/i;
//
//   return mobileRegex.test(userAgent.toLowerCase());
// }

export const getDeviceInfo = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      browser: "unknown",
      os: "unknown",
    };
  }

  try {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const ua = userAgent.toLowerCase();

    // Detect OS
    let os = "unknown";
    if (/windows/i.test(ua)) os = "windows"
    else if (/mac os/i.test(ua)) os = "macos"
    else if (/linux/i.test(ua)) os = "linux"
    else if (/android/i.test(ua)) os = "android"
    else if (/iphone|ipad|ipod/i.test(ua)) os = "ios";

    // Detect browser
    let browser = "unknown";
    if (/chrome/i.test(ua) && !/edge|edg/i.test(ua)) browser = "chrome"
    else if (/safari/i.test(ua) && !/chrome/i.test(ua)) browser = "safari"
    else if (/firefox/i.test(ua)) browser = "firefox"
    else if (/edge|edg/i.test(ua)) browser = "edge"
    else if (/opera|opr/i.test(ua)) browser = "opera";

    return {
      isMobile: _.isMobile(),
      isTablet: _.isTablet(),
      isDesktop: _.isDesktop(),
      browser,
      os,
      platform: _.get(navigator, 'platform', 'unknown')
    }
  } catch (error) {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      browser: "unknown",
      os: "unknown",
      platform: "unknown"
    }
  }
}
